/* @flow */
import styled from 'styled-components'
import THEME from './Spotify6.theme'
import {
  styleProvider,
  getBackgroundStyles,
  getTextStyleByAlignment
} from '@website/common/utils'
import WMContainer from '@website/common/components/WMContainer'
import Container from '@website/common/components/Container'

const getStyleForProp = styleProvider(THEME)

const WmCustomContainer = styled(WMContainer)`
  max-width: 1100px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 0;
  @media only screen and (max-width: 1024px) {
    flex-direction: column;
  }
`
const StyledContainer = styled(Container)`
  ${getBackgroundStyles(THEME)};
  flex-direction: column;
  padding: ${({ isEditing }) => (isEditing ? '150px 0 80px 0' : '80px 0')};
  @media only screen and (max-width: 457px) {
    padding: ${({ isEditing }) => (isEditing ? '120px 0 60px 0' : '60px 0')};
  }
`

const TextContent = styled.div`
  width: 100%;
  max-width: 500px;
  display: flex;
  flex-direction: column;
  @media only screen and (max-width: 1024px) {
    max-width: 100%;
  }
  > :last-child {
    margin-bottom: 0;
  }
  & > .control-container {
    margin-bottom: 30px;
    h1 {
      margin-bottom: 0;
    }
  }
`

const Title = styled.h1`
  color: ${getStyleForProp('heading')};
  ${getTextStyleByAlignment};
  margin-bottom: 20px;
`

const Paragraph = styled.p`
  color: ${getStyleForProp('paragraph')};
  ${getTextStyleByAlignment};
`

const MusicWrapper = styled.div`
  width: 300px;
  min-width: 300px;
  font-size: 0;
  margin: 0 0 0 35px;
  @media only screen and (min-width: 1024px) {
    &:only-child {
      margin: auto;
    }
  }
  @media only screen and (max-width: 1024px) {
    margin: 40px 0 0 0;
    &:only-child {
      margin: 0;
    }
  }
  @media only screen and (max-width: 650px) {
    margin: 50px 0 0 0;
    &:only-child {
      margin: 0;
    }
  }
`

const MusicContent = styled.div`
  border-radius: ${getStyleForProp('badgeRadius')};
  overflow: hidden;
  position: relative;
  width: 100%;
`

const IframeWrapper = styled.div`
  width: 100%;
  position: relative;
  iframe {
    width: 100%;
    aspect-ratio: 1/1.38;
    // height: 352px;
    border-radius: ${getStyleForProp('badgeRadius')};
    -webkit-mask-image: -webkit-radial-gradient(white, black);
  }
`

export default {
  WmCustomContainer,
  StyledContainer,
  Title,
  Paragraph,
  MusicContent,
  IframeWrapper,
  TextContent,
  MusicWrapper
}
